import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';

export default function WorkingHoursOverviewDrawer(props) {
    const classes = useStyles();

    function convertWorkingHours() {

        let convertedWorkingHours = []
        let daysOfTheWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

        var i;
        for (i = 0; i < props.workstation.workingHours.length; i++) {

            if (convertedWorkingHours.some(x => x.workstation === props.workstation.workingHours[i].workstation)) {
                if(props.workstation.workingHours[i].start === "00:00" && props.workstation.workingHours[i].end === "00:00"){
                    convertedWorkingHours.find(x => x.workstation === props.workstation.workingHours[i].workstation).days.push({ day: daysOfTheWeek[props.workstation.workingHours[i].day], start: "/", end: "/" })
                }
                else{
                    convertedWorkingHours.find(x => x.workstation === props.workstation.workingHours[i].workstation).days.push({ day: daysOfTheWeek[props.workstation.workingHours[i].day], start: props.workstation.workingHours[i].start, end: props.workstation.workingHours[i].end })
                }
            }
            else {
                if(props.workstation.workingHours[i].start === "00:00" && props.workstation.workingHours[i].end === "00:00"){
                    convertedWorkingHours.push({ workstation: props.workstation.workingHours[i].workstation, days: [{ day: daysOfTheWeek[props.workstation.workingHours[i].day], start: "/", end: "/" }] })
                }
                else{
                    convertedWorkingHours.push({ workstation: props.workstation.workingHours[i].workstation, days: [{ day: daysOfTheWeek[props.workstation.workingHours[i].day], start: props.workstation.workingHours[i].start, end: props.workstation.workingHours[i].end }] })
                }
            }
        }

        return convertedWorkingHours;
    }

    const rows = convertWorkingHours().sort((a, b) => parseFloat(a.workstation) - parseFloat(b.workstation)).map(workingHour =>

        createData(workingHour.workstation, workingHour.days)
    )

    function createData(workstation, days) {
        return { workstation, days };
    }


    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(false);

        return (
            <React.Fragment>
                <TableRow className={classes.row}>
                    <TableCell className={classes.arrowCell}>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row" className={classes.workstationCell}>
                        {"Production line " + row.workstation}
                    </TableCell>
                </TableRow>
                <TableRow className={classes.row}>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                                <Table aria-label="workingHours">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.headCell}>Day</TableCell>
                                            <TableCell className={classes.headCell}>Start shift</TableCell>
                                            <TableCell className={classes.headCell}>End shift</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.days.map((row) => (
                                            <TableRow key={row.day} className={classes.row}>
                                                <TableCell component="th" scope="row" className={classes.infoCell}>
                                                    {row.day}
                                                </TableCell>
                                                <TableCell className={classes.infoCell}>{row.start}</TableCell>
                                                <TableCell className={classes.infoCell}>{row.end}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>Working hours</div>
                <button className={classes.editButton} onClick = {() => props.openEditWorkingHoursDrawer(true)}>
                    <div className={classes.editIconContainer}><img className={classes.editIcon} alt="pencil" src={process.env.PUBLIC_URL + '/img/pencil.svg'}></img></div>
                    <div className={classes.editWorkingHours}>Edit working hours</div>
                </button>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}></TableCell>
                            <TableCell className={classes.headCell} style={{ paddingLeft: "10px" }}>Production line</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <Row key={row.workstation} row={row} />
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    </Drawer >
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "15px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "40%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "10%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "50%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px"
    },

    header: {
        width: "100%",
        height: "5%",
        marginBottom: "40px"
    },
    infoCell: {
        padding: "10px !important",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    workstationCell: {
        padding: "10px !important",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        marginBottom: "5px",
        borderRadius:"0 7px 7px 0"
    },
    arrowCell: {
        padding: "10px !important",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        width: "5%",
        marginBottom: "5px",
        borderRadius:"7px 0 0 7px"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "white",
        },
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        padding: "3px",
        paddingTop: "0px",
    },
    editIconContainer: {
        float: "left",
        color: FlagstoneTheme.palette.primary.main,
        marginRight: "10px",
        paddingTop: "2px"
    },
    editWorkingHours: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: FlagstoneTheme.palette.primary.main,
        float: "left",
        paddingTop: "3px"
    },
    editButton: {
        outline: 'none',
        border: "none",
        cursor: "pointer",
        float: "left",
        width: "40%",
        paddingTop: "20px",
        paddingLeft: "120px"
    },
    table: {
        borderSpacing: "0 3px !important",
        borderCollapse: "separate !important"
    }

}));